import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { copy } from '../data/copy';
import { business } from '../data/business';
export function ServiceArea() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist" data-id="element-300" data-mp="nalpopib0eda">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-301" data-mp="n9k2xnrxe3fq">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.3fr] lg:items-center lg:gap-14" data-id="element-302" data-mp="11yglierlyyul">
          <div data-id="element-303" data-mp="x0oioppfdsbm">
            <p className="font-display text-sm font-bold text-bright" data-id="element-304" data-mp="wz3mywrdk3c6">{t(copy.areaKicker)}</p>
            <h2 className="mt-2 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-305" data-mp="1b07q1gaewzmv">
              {t(copy.areaTitle)}
            </h2>
            <p className="mt-5 text-base leading-relaxed text-charcoal/70" data-id="element-306" data-mp="3cr19ieniu105">{t(copy.areaBody)}</p>

            <ul className="mt-8 space-y-3 text-sm" data-id="element-307" data-mp="38pz7jq27zauh">
              <li className="flex items-center gap-3 text-charcoal/80" data-id="element-308" data-mp="38racht7eion6">
                <MapPinIcon className="h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-309" data-mp="1a8qagfw50j4b" />
                {t(copy.areaRadius)}
              </li>
              <li className="flex items-center gap-3 text-charcoal/80" data-id="element-310" data-mp="1f4ytw5hdayha">
                <ClockIcon className="h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-311" data-mp="1k5csyy0zqy36" />
                {t(copy.areaHours)}
              </li>
              <li data-id="element-312" data-mp="1tvxyz6izv4w4">
                <a href={business.phoneHref} className="flex items-center gap-3 font-display font-bold text-royal transition-colors duration-150 ease-out hover:text-bright" data-id="element-313" data-mp="1twh5zs73w8vd">
                  <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-314" data-mp="22xxh625qwf0n" />
                  {business.phone}
                </a>
              </li>
              <li data-id="element-315" data-mp="8il4eon1d3vq">
                <a href={business.emailHref} className="flex items-center gap-3 text-charcoal/80 transition-colors duration-150 ease-out hover:text-royal" data-id="element-316" data-mp="8j4mc5cors9r">
                  <MailIcon className="h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-317" data-mp="5g8aaud8e4gs" />
                  {business.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl border border-navy/10 bg-white p-2 shadow-card" data-id="element-318" data-mp="ffpfzbshgicr">
            <iframe title={t(copy.areaMapTitle)} src={business.mapEmbed} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-[320px] w-full rounded-2xl border-0 sm:h-[420px]" data-id="element-319" data-mp="aftjdxm47t78" />
          </div>
        </div>
      </div>
    </section>;
}